import {ToastMessageOptions} from 'primevue'

type PracsysSeverity = ToastMessageOptions['severity']

export type PracsysNotification = BasicNotification //| DialogNotification | TargetingRouterLinkNotification

export type BasicNotification = {
    type?: 'basic'
    title: string
    //TODO: 2025-09-11 kjetil, object is only a temporary fix, should be removed and resolved as a DialogNotification. Waiting on prime-vue vs nuxt ui conclusion.
    description: string
}

export type PracsysErrorNotification = BasicErrorNotification

type BasicErrorNotification = Omit<BasicNotification, 'description'> & {
    description: string | { descriptionMessage: string, error: any }
}

// TODO: DialogNotification -> clickable open dialog with detail
// export type DialogNotification = Pick<BasicNotification, 'summary'> & {
//     type: 'dialog'
//     detail: Object
// }

// TODO: TargetingRouterLinkNotification -> link to item.
// type TargetingRouterLinkNotification = Pick<BasicNotification, 'summary'> & {
//     type: 'targeting'
// }

export type NotificationHandlers = {
    notifySuccess: typeof notifySuccess
    notifyError: typeof notifyError
    notifyWarning: typeof notifyWarning
    notifyInfo: typeof notifyInfo
}

let _handlers: NotificationHandlers | null = null

export const registerNotificationHandlers = (handlers: NotificationHandlers) => {
    _handlers = handlers
}

export const notifySuccess = (notification: PracsysNotification) => {
    handleNotify({type: 'basic', title: notification.title, description: notification.description}, 'success')
}

export const notifyError = (notification: PracsysErrorNotification) => {
    handleNotify({type: 'basic', title: notification.title, description: notification.description}, 'error')
}

export const notifyWarning = (notification: PracsysNotification) => {
    handleNotify({type: 'basic', title: notification.title, description: notification.description}, 'warn')
}

export const notifyInfo = (notification: PracsysNotification) => {
    handleNotify({type: 'basic', title: notification.title, description: notification.description}, 'info')
}

const handleNotify = (notification: PracsysNotification | PracsysErrorNotification, severity: PracsysSeverity) => {
    if (!_handlers) {
        console.warn('Notification handlers not registered!')
        return
    }
    switch (severity) {
        case 'success':
            _handlers.notifySuccess(notification as PracsysNotification)
            break
        case 'error':
            _handlers.notifyError(notification as PracsysErrorNotification)
            break
        case 'warn':
            _handlers.notifyWarning(notification as PracsysNotification)
            break
        case 'info':
            _handlers.notifyInfo(notification as PracsysNotification)
            break
        default:
            console.warn('Unhandled notification severity!')
            _handlers.notifyInfo(notification as PracsysNotification)
    }
}
